import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, ShieldCheck, Sparkles } from 'lucide-react';
import WazinWatermark from '../WazinWatermark';

const LaborStandaloneLayout = ({ children, footerNote, badgeText = null }) => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  const fallbackBadgeText = isArabic ? 'بوابة وازن العمالية' : 'Wazin Labor Portal';

  const toggleLanguage = () => {
    const nextLanguage = isArabic ? 'en' : 'ar';
    i18n.changeLanguage(nextLanguage);
    document.documentElement.dir = nextLanguage === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = nextLanguage;
  };

  return (
    <div className="min-h-screen bg-[#f8f6f1]" dir={isArabic ? 'rtl' : 'ltr'}>
      <WazinWatermark opacity={0.08} size="large" position="center" />

      <div className="relative z-10 flex min-h-screen flex-col">
        <header className="sticky top-0 z-40 border-b border-[#C8A870]/15 bg-white/90 backdrop-blur-xl">
          <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-4">
              <div>
                <div className="flex items-center gap-2">
                  <img
                    src="/images/wazin-logo.png"
                    alt="Wazin Logo"
                    className="h-20 w-auto object-contain sm:h-24 lg:h-28"
                  />
                  <span className="hidden rounded-full bg-[#A27849]/10 px-3 py-1 text-xs font-bold text-[#A27849] sm:inline-flex">
                    {badgeText || fallbackBadgeText}
                  </span>
                </div>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-2 rounded-full border border-[#C8A870]/25 bg-[#f8f6f1] px-3 py-1.5 text-xs font-semibold text-[#1F3B64]">
                    <ShieldCheck className="h-3.5 w-3.5 text-[#A27849]" />
                    {isArabic ? 'بوابة القضايا العمالية' : 'Labor Cases Portal'}
                  </span>
                  <span className="inline-flex rounded-full border border-[#C8A870]/20 bg-white px-3 py-1.5 text-xs text-slate-500">
                    {isArabic ? 'صفحة مخصصة لتقديم البيانات والمستندات' : 'A page dedicated to submitting information and documents'}
                  </span>
                </div>
              </div>
            </div>

            <button
              type="button"
              onClick={toggleLanguage}
              className="inline-flex items-center gap-2 rounded-full border border-[#C8A870]/30 bg-white px-4 py-2 text-sm font-bold text-[#1F3B64] transition hover:bg-[#f8f6f1]"
            >
              <Globe className="h-4 w-4" />
              {isArabic ? 'AR / EN' : 'العربية'}
            </button>
          </div>
        </header>

        <div className="flex-1">{children}</div>

        <footer className="border-t border-[#C8A870]/15 bg-white/80">
          <div className="mx-auto max-w-7xl px-4 py-6 text-center sm:px-6 lg:px-8">
            <div className="inline-flex items-center gap-2 rounded-full bg-[#1F3B64]/5 px-4 py-2 text-sm text-slate-600">
              <Sparkles className="h-4 w-4 text-[#A27849]" />
              {footerNote || (isArabic ? 'منصة وازن قيد الإطلاق التدريجي.' : 'Wazin platform is being launched gradually.')}
            </div>
            <p className="mt-3 text-xs text-slate-400">
              © 2026 Wazin Law Firm
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default LaborStandaloneLayout;
